export default __webpack_public_path__ + "static/media/001-W-unions.1c5fe6e4.svg";